export default "__VITE_ASSET__CVYhJQid__"